
import{ findComponentUpward } from '@/assets/common/component';
import {round, divide} from "number-precision";
import moment from 'moment';
export default {

    data() {
        return {
            
        }
    },
    methods: {
        doClose() {
            const dialog = findComponentUpward(this, "ElDialog");
            if(dialog) {
                dialog.$emit('update:visible', false);
                return true;
            }
            return false;
        },
        _getDictLabel(dict, value) {
            if (dict && value) {
				const item = dict.find((e) => e.value == value);
				return item.label;
			}else {
                return '';
            }
        }
    },
    filters: {
        dictLabel(value, dict) {
            if (dict && value) {
				const item = dict.find((e) => e.value == value);
				return item.label;
			}else {
                return '';
            }
        },
        toYuan(value) {
            let val = value;
            if(val) {
                if(!Number.isFinite(val)) {
                    val = Number.parseFloat(val);
                    if(Number.isNaN(val)) {
                        return value;
                    }
                }
                return round(divide(value, 100), 2);
            }else {
                return value;
            }
        },
        dateFmt(value, fmt) {
            if(value) {
                try {
                    return moment(value).format(fmt);
                }catch(e) {
                    console.error(e)
                    return "";
                }
            }else {
                "";
            }
        }
    }
}